import React from 'react';


// Components

import Bread from '../components/Bread';
import RegisterComponent from '../components/Register';

const Register = () => {
  return (<>
          
              <Bread title="SignUp Form" des="We are team of talanted designers making Web and Native Apps" />
              <RegisterComponent />
          
        </>)}

export default Register;
